import { z } from 'zod';

export const RetrieveUserCalendarSchema = z.object({
  userId: z.string(),
});

export type RetrieveUserCalendar = z.infer<typeof RetrieveUserCalendarSchema>;
